// src/components/Snackbar.js
import React, { useEffect, useState } from 'react';
import '../styles/snackbar.css'; // This is where you'll do ALL your custom design

const Snackbar = ({
  message,
  type = 'info', // 'success', 'error', 'warning', 'info' (default)
  open,
  onClose,
  duration = 3000, // Default duration in milliseconds
  position = 'bottom-center', // e.g., 'bottom-left', 'top-right', etc.
  customStyles = {}, // For inline style overrides if absolutely needed
}) => {
  const [isVisible, setIsVisible] = useState(open);

  useEffect(() => {
    setIsVisible(open); // Sync with parent's open prop

    let timer;
    if (open && duration > 0) { // Only set timer if duration is positive
      timer = setTimeout(() => {
        handleClose();
      }, duration);
    }
    return () => clearTimeout(timer); // Cleanup timer
  }, [open, duration]); // Re-run effect if `open` or `duration` changes

  const handleClose = () => {
    setIsVisible(false);
    if (onClose) {
      onClose(); // Notify parent to update its state
    }
  };

  if (!isVisible) {
    return null;
  }

  // Base class + type class + position class
  const snackbarClasses = `snackbar snackbar-${type} snackbar-position-${position} ${
    isVisible ? 'show' : ''
  }`;

  return (
    <div className={snackbarClasses} style={customStyles}>
      <span className="snackbar-message">{message}</span>
      {/* You can add a close button if you want users to manually dismiss it */}
      {onClose && ( // Only show close button if onClose is provided
        <button onClick={handleClose} className="snackbar-close-button">
          ×
        </button>
      )}
    </div>
  );
};

export default Snackbar;